<template>
  <header>
    <b-navbar toggleable="lg" type="dark" fixed="top" class="p-0" :style="{ backgroundColor : backgroundColor }">
      <b-container class="navbar-shadow">
        <b-navbar-brand :to="{ name: 'Home' }" exact-active-class="" active-class=""><img :src="logoImage">
        </b-navbar-brand>

        <b-navbar-toggle target="nav_collapse" class="mr-2"></b-navbar-toggle>

        <b-collapse is-nav id="nav_collapse">
          <b-navbar-nav class="ml-auto">
            <b-nav-item :to="{ name: 'Home' }" exact-active-class="active" active-class="" class="app-nav-item">HOME
            </b-nav-item>
            <b-nav-item :to="{ name: 'About' }" exact-active-class="active" active-class="" class="app-nav-item">
              SOBRE NÓS
            </b-nav-item>
            <b-nav-item :to="{ name: 'ProjectList' }" class="app-nav-item">PORTFOLIO</b-nav-item>
            <b-nav-item :to="{ name: 'SocialWorks' }" exact-active-class="active" active-class="" class="app-nav-item">
              OBRAS SOCIAIS
            </b-nav-item>
            <b-nav-item class="app-nav-item" @click.prevent="scrollTo('.contact-section')">CONTATO</b-nav-item>
          </b-navbar-nav>
        </b-collapse>
      </b-container>
    </b-navbar>
  </header>
</template>

<script>
  import $ from 'jquery';
  import logoImage from '../../assets/disclosure/logo.svg';

  export default {
    data() {
      return {
        logoImage,
        backgroundColor: 'transparent',
        backgroundColorChangeOffset: 0,
        scrollToDelay: 500
      }
    },
    methods: {
      width() {
        return Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
      },
      changeBackgroundColorOnScroll() {
        $(document).scroll(() => {
          this.changeBackgroundColor();
        });
      },
      changeBackgroundColor() {
        if (this.width() > 991.98) {
          const scrollPosition = $(document).scrollTop();
          this.backgroundColor = scrollPosition > this.backgroundColorChangeOffset ? 'black' : 'transparent';
        } else {
          this.backgroundColor = 'black';
        }
      },
      scrollTo(selector) {
        $('html, body').animate({
          scrollTop: ($(selector).offset().top - 80)
        }, this.scrollToDelay, 'swing');
      },
      fixMenu() {
        const spanSelector = '.navbar-toggler > span';
        $(spanSelector).removeClass('navbar-toggler-icon').text("MENU");
        $(spanSelector).css("color", "#dddddd");
        $(spanSelector).css("font-family", "OpenSans, sans-serif");
        $('.navbar-toggler').css("border-color", "#dddddd");
      }
    },
    watch: {
      $route(to, from) {
        this.changeBackgroundColor();
      }
    },
    created() {
      this.changeBackgroundColorOnScroll();
      this.changeBackgroundColor();
      window.addEventListener("resize", () => {
        this.changeBackgroundColor();
      });
    },
    mounted () {
      this.fixMenu();
    }
  }
</script>

<style scoped>
  header {
    z-index: 999998;
    box-shadow: 2px 2px black;
  }

  .navbar-brand img {
    height: 46px;
    margin: 10px;
  }

  .app-nav-item {
    font-family: "OpenSans-Bold", Helvetica, Arial, sans-serif;
  }

  .app-nav-item a {
    border-top: 10px solid transparent;
    height: 80px;
    line-height: 45px;
    text-align: center;
  }

  .active {
    border-top: 10px solid #1cb9ff !important;
  }

  .navbar-toggler {
    font-family: "OpenSans-Bold", Helvetica, Arial, sans-serif;
    font-size: 16px;
    padding: 10px 10px;
  }

  @media (max-width: 991px) {
    .active {
      border-top: 10px solid transparent !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/navigation/Header.vue